import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=3c4366ff&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=3c4366ff&prod&scoped=true&lang=css"
import style1 from "./BarChart.vue?vue&type=style&index=1&id=3c4366ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4366ff",
  null
  
)

export default component.exports